import { FC } from 'react';

const PageNotFoundIllustration: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
  >
    <path
      fill="#1D1D1D"
      d="M49.778 37.444a4.444 4.444 0 1 0 0-8.888 4.444 4.444 0 0 0 0 8.888M34.667 33a4.444 4.444 0 1 1-8.89 0 4.444 4.444 0 0 1 8.89 0"
    ></path>
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M72 41c0 17.673-14.327 32-32 32S8 58.673 8 41 22.327 9 40 9s32 14.327 32 32m-5.333 0c0 14.728-11.94 26.667-26.667 26.667S13.333 55.727 13.333 41 25.273 14.333 40 14.333 66.667 26.273 66.667 41"
      clipRule="evenodd"
    ></path>
    <path fill="#1D1D1D" d="M27 48h26v5H27z"></path>
  </svg>
);

export default PageNotFoundIllustration;
